/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/statistics/components/artikel-einkauf-view/statistics.artikel-einkauf-view.component.ts.
 */
import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {StatisticsService} from '../../services/statistics.service';
import {Lieferkunde} from '../../../../models/lieferkunde';
import {AppLieferkundeService} from '../../../../services/app.lieferkunde.service';
import {Subscription} from 'rxjs';
import {AppUserService} from '../../../../services/app.user.service';
import {AppConfigService} from '../../../../services/app.config.service';
import {SupplierOrderStatisticEntry} from '../../../../models/supplier-order-statistic-entry';
import {AppKeyValueStorageService} from '../../../../services/app.key-value-storage.service';

/**
 * Zweck: Beschreibt class StatisticsArtikelEinkaufViewComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'statistic-artikel-einkauf-view',
    templateUrl: 'statistics.artikel-einkauf-view.component.html',
    styleUrls: ['statistics.artikel-einkauf-view.component.scss'],
    standalone: false
})
export class StatisticsArtikelEinkaufViewComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() pzn: string;
  @Input() artNr: number;
  @Input() artName: string;
  lcustomers: Lieferkunde[];
  year: number;

  years = [];

  lksub: Subscription;

  supplierStats: SupplierOrderStatisticEntry[];


  @ViewChild('box') box: ElementRef;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private lksvc: AppLieferkundeService, private ssvc: StatisticsService, private usvc: AppUserService,
              private cfg: AppConfigService, private kvstc: AppKeyValueStorageService) {
  }

/**
 * Beschreibt Methode changeYear und ihren Rückgabevertrag.
 */
  changeYear() {
    this.loadLieferantenstat();
    this.kvstc.save4User('StatisticsArtikelEinkaufSelectedYear', this.year).subscribe(() => {

    });
  }

/**
 * Beschreibt Methode loadLieferantenstat und ihren Rückgabevertrag.
 */
  loadLieferantenstat() {
    if (this.cfg.featuresEnabled(['Lieferantenbestellung'])) {
      this.usvc.hasRoles(['Lieferantenbestellung']).subscribe(hasRole => {
        if (hasRole && this.pzn && this.year) {
          this.ssvc.getSuppliersArtikelEinkaufsStatistic(this.pzn, this.year).subscribe(stat => {
            this.supplierStats = stat;
          });
        }
      });
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.lksub = this.lksvc.current_lieferkunde.subscribe(lk => this.lcustomers = [lk]);
    this.years = [(new Date()).getFullYear(), (new Date()).getFullYear() - 1];
    this.kvstc.load4User('StatisticsArtikelEinkaufSelectedYear').subscribe(y => {
      if (y && this.years.includes(y)) {
        this.year = y;
      } else {
        this.year = (new Date()).getFullYear();
      }
      this.loadLieferantenstat();
    });
  }

/**
 * Beschreibt Methode trySetWidth und ihren Rückgabevertrag.
 */
  trySetWidth() {
  }

/**
 * Beschreibt Methode ngAfterViewInit und ihren Rückgabevertrag.
 */
  ngAfterViewInit() {
    this.box.nativeElement.style.width = (window.outerWidth - 966 - 30) + 'px';
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.lksub instanceof Subscription) {
      this.lksub.unsubscribe();
    }
  }


}
